import { useContext } from "react";
import { AppContext, AppNewState } from "./";

export const useAppState = () => {
  const { appState, setAppState } = useContext(AppContext);
  const updater = (newState: AppNewState) => {
    setAppState(newState);
  };
  return [appState, updater] as const;
};
